import React from 'react';
import Icon from '../../../components/AppIcon';

const Timeline = () => {
  const milestones = [
    {
      year: "2019",
      title: "The Inspiration",
      description: "Rajesh and Maria meet in Mexico City, discovering the magic of authentic street food culture",
      icon: "Lightbulb"
    },
    {
      year: "2020",
      title: "First Cart Launch",
      description: "Started with a single food cart in Indiranagar, serving 50 customers daily with authentic halal tacos",
      icon: "Store"
    },
    {
      year: "2021",
      title: "First Restaurant",
      description: "Opened our flagship location in Koramangala, expanding menu and seating for 80 guests",
      icon: "Home"
    },
    {
      year: "2022",
      title: "Halal Certification",
      description: "Achieved official halal certification, reinforcing our commitment to inclusive dining",
      icon: "Award"
    },
    {
      year: "2023",
      title: "Multi-Location Expansion",
      description: "Expanded to HSR Layout and Whitefield, serving 500+ customers daily across Bengaluru",
      icon: "MapPin"
    },
    {
      year: "2024",
      title: "Community Impact",
      description: "Partnered with 15 local suppliers, created 50+ jobs, and served 100,000+ happy customers",
      icon: "Users"
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl sm:text-5xl font-bold text-foreground mb-4">
            Our <span className="text-primary">Journey</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            From a single cart to a beloved Bengaluru destination
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-primary/20 hidden lg:block"></div>

          <div className="space-y-12">
            {milestones?.map((milestone, index) => (
              <div
                key={index}
                className={`relative flex items-center ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                } flex-col gap-8 animate-slide-up`}
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className={`lg:w-1/2 ${index % 2 === 0 ? 'lg:text-right lg:pr-12' : 'lg:text-left lg:pl-12'}`}>
                  <div className="bg-card p-6 rounded-xl border border-border hover:border-primary transition-all duration-300 hover:shadow-md">
                    <div className="flex items-center gap-3 mb-3 lg:justify-end" style={{ justifyContent: index % 2 === 0 ? 'flex-end' : 'flex-start' }}>
                      <span className="text-3xl font-bold text-primary">{milestone?.year}</span>
                      <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center lg:hidden">
                        <Icon name={milestone?.icon} size={20} color="var(--color-primary)" />
                      </div>
                    </div>
                    <h3 className="text-xl font-semibold text-foreground mb-2">{milestone?.title}</h3>
                    <p className="text-muted-foreground">{milestone?.description}</p>
                  </div>
                </div>

                <div className="hidden lg:flex absolute left-1/2 transform -translate-x-1/2 w-16 h-16 rounded-full bg-primary flex items-center justify-center shadow-lg z-10">
                  <Icon name={milestone?.icon} size={28} color="#FFFFFF" />
                </div>

                <div className="lg:w-1/2"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Timeline;